'use client'

import { Loader, Spacer, Text } from '@vinted/web-ui'
import { useEffect, useState } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const LoadingComponent = () => {
  const translate = useTranslate('help_center.ai_search')

  const loadingMessages = [
    'loading_text_1',
    'loading_text_2',
    'loading_text_3',
    'loading_text_4',
    'loading_text_5',
  ]

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentMessageIndex(prevIndex => (prevIndex + 1) % loadingMessages.length)
    }, 2000)

    return () => clearInterval(intervalId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getButtonTranslationKey = () => {
    return loadingMessages[currentMessageIndex] || ''
  }

  return (
    <div className="u-flexbox u-align-items-center">
      <Loader size="medium" />
      <Spacer orientation="vertical" size="large" />
      <Text as="h3" text={translate(getButtonTranslationKey())} type="title" theme="muted" />
    </div>
  )
}

export default LoadingComponent
